<style src="./Like.scss" lang="scss"></style>

<template lang="pug">
  .like(
    :class='classList'
  )
    button.like__button(
      @click='liked ? $emit("unlike") : $emit("like")'
      :title='liked ? $l10n("REMOVE_FROM_FAVORITES") : $l10n("ADD_TO_FAVORITES")'
      type='button'
    )
      .like__icon
        Icon(
          :name='liked ? "heartFilled" : "heart"'
        )
        
    .like__count(
      v-if='count'
    ) {{ count | likes }}
</template>
<script>
import Icon from "@/components/Icon/Icon";

export default {
  props: ["liked", "count", "color", "size"],
  inheritAttrs: false,
  computed: {
    classList() {
      return {
        [`is-${this.color}`]: this.color,
        [`is-${this.size}`]: this.size,
        "is-liked": this.liked
      };
    }
  },
  components: { Icon }
};
</script>
